import { css, SerializedStyles } from '@emotion/react';
import { theme, WeaveTheme } from '@frontend/theme';
import { FontColorType, getFontColorStyle } from '../helpers';

export type IconStyleProps = {
  color?: FontColorType;
  size: number;
  noFill?: boolean;
};

export type IconThemeValues = {
  fontColorStyle: SerializedStyles | null;
  iconSize: string;
};

export type IconProps = {
  color?: FontColorType;
  size: number;
};

const getThemedFontColorStyle = (color: FontColorType, theme: WeaveTheme) => getFontColorStyle(color, theme);

export const getIconTheme = ({ size, color }: IconProps) => ({
  iconSize: theme.fontSize(size),
  fontColorStyle: color ? getThemedFontColorStyle(color, theme) : null,
});

const styles = ({ size, color, noFill }: IconStyleProps, { minWidth }: { minWidth: number }) => {
  const iconSize = theme.fontSize(size);
  const fontColorStyle = color ? getFontColorStyle(color, theme) : null;

  return [
    fontColorStyle,
    css`
      /* Keeps size consistent inside flex parents */
      min-width: ${minWidth}px;
      transition: fill 200ms ease-out;
      user-select: none;
      line-height: 1;
      font-size: ${iconSize};
    `,
    noFill &&
      css`
        fill: none;
      `,
    !noFill &&
      css`
        fill: currentColor;
      `,
  ];
};

export const IconStyles = {
  icon: (iconProps: IconStyleProps) => styles(iconProps, { minWidth: iconProps.size }),
};
